import { render, staticRenderFns } from "./TeamArea.vue?vue&type=template&id=6da2b5f1&scoped=true&"
import script from "./TeamArea.vue?vue&type=script&lang=js&"
export * from "./TeamArea.vue?vue&type=script&lang=js&"
import style0 from "./TeamArea.vue?vue&type=style&index=0&id=6da2b5f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2b5f1",
  null
  
)

export default component.exports